import debounceFn from 'lodash.debounce';
import { InferableFunction } from 'types';

type DebounceOptions = {
  /**
   * Specify invoking on the leading edge of the timeout
   * @default false
   */
  leading?: boolean;
  /**
   * The maximum time func is allowed to be delayed before it's invoked.
   */
  maxWait?: number;
  /**
   * Specify invoking on the trailing edge of the timeout.
   * @default true
   */
  trailing?: boolean;
};

/**
 * https://lodash.com/docs/4.17.15#debounce
 */
export const debounce = <F extends InferableFunction>(func: F, wait?: number, options?: DebounceOptions): F => {
  // In test environment, return function immediately without debouncing
  if (typeof process !== 'undefined' && process.env.NODE_ENV === 'test') {
    return func;
  }

  // Check if we're in Jasmine test environment
  if (typeof jasmine !== 'undefined') {
    return func;
  }

  return debounceFn(func, wait, options);
};
